export const faqs = [
  {
    q: "提交爆料需要注册账号或填写真实身份吗？",
    a: "不需要。投稿入口默认匿名，不要求注册账号，也不强制填写真实姓名。联系方式为选填项，留空同样可以提交。平台只做最小化留存，用于必要时核对线索细节。",
  },
  {
    q: "可以提交聊天截图、文件或图片材料吗？",
    a: "可以提交。建议在正文中用文字先说清时间、地点与事件经过，再补充材料说明。若材料包含个人信息，请先做打码处理，避免不必要的隐私暴露。",
  },
  {
    q: "投稿之后多久会有反馈？",
    a: "一般线索会在 48 小时内完成首轮归类，复杂线索通常需要 3 到 5 个工作日。如果归类后有新的疑问，我们会尝试通过你留下的联系方式核对细节。",
  },
  {
    q: "平台如何对待同一事件的不同说法？",
    a: "平台不对事件下结论。对于存在争议的内容，我们会把多方说法并列呈现，并标注各自的来源与提交时间，读者可以自行判断。",
  },
  {
    q: "被提及的一方可以要求更正或补充说明吗？",
    a: "可以。相关方可通过联系入口提交补充说明或更正申请，我们会核对后更新原文，并在页面保留修改记录，方便追溯。",
  },
  {
    q: "线索公开后还能修改吗？",
    a: "可以。若后续出现新的进展或事实更正，平台会在对应入口同步更新，状态会标注为“已更新”，原文保留修改说明。",
  },
  {
    q: "平台会替投稿人或当事方维权吗？",
    a: "平台是线索归档与信息汇总中心，提供的是公开、可追溯的记录，不代理任何一方的诉求，也不参与具体纠纷处理。",
  },
];

export default faqs;